export default __webpack_public_path__ + "static/media/prev-elevate.7ca36991.jpg";